<script setup>
</script>

<template>
    <h6 class="card-subtitle text-muted mb-1">
        <slot></slot>
    </h6>
</template>